const initialState = {
  worldCupShareOgImage: '',
  bahistaShareOgImage: ''
};

export default function ssrMetaReducer (state = initialState) {
  return state;
}
